export class UserTypeAright {
  user_type_id: number;
  companyHierarchy: string;
  disableAutoRights: boolean;
  enableOwnData: boolean;
  reportAccess: string;
}
